/**
 * Arranque de la aplicación.
 *
 * Este archivo solo monta React en el HTML. Toda la configuración
 * (React Query, router, avisos) está en `app/Providers.tsx`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "@/app/Providers";
import { recargarPorVersionNueva } from "@/lib/recargaPorVersion";
import "./index.css";

// Un trozo de la versión vieja que ya no está en el servidor: se recarga una
// vez y llega la nueva. Ver `recargaPorVersion.ts`. `preventDefault` evita que
// Vite lance el error mientras la página ya se está recargando.
window.addEventListener("vite:preloadError", (evento) => {
  if (recargarPorVersionNueva()) evento.preventDefault();
});

const contenedor = document.getElementById("root");
if (!contenedor) throw new Error('No se encontró el elemento <div id="root"> en index.html');

createRoot(contenedor).render(
  <StrictMode>
    <Providers />
  </StrictMode>,
);
